import { Component, Input, ViewChild } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import * as moment from 'moment';
import { Moment } from 'moment';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY-MM',
    dateA11yLabel: 'YYYY-MM-DD',
    monthYearA11yLabel: 'YYYY-MM',
  },
};


@Component({
  selector: 'detail-view-item',
  template: `
    <mat-list class="detail-view-item-list">
      <mat-list-item class="detail-view-item-list-item-container">
        <div [ngClass]="{
          'vertical-display': displayMode === 'vertical',
          'horizontal-display': displayMode === 'horizontal'
        }">
          <span [ngClass]="{
            'title-left-align': titleTextAlign === 'left',
            'title-right-align': titleTextAlign === 'right',
            'title-center-align': titleTextAlign === 'center'
          }" class="detail-view-item-list-item-title" [style.width]="getTitleWidth()">
            {{ title }}
          </span>
          <span [ngClass]="{
            'value-left-align': textAlign === 'left',
            'value-right-align': textAlign === 'right',
            'value-center-align': textAlign === 'center'
          }" class="detail-view-item-list-item-value"
            [style.white-space]="whiteSpace">
            <a *ngIf="isLink" href="#" (click)="onValueClick($event)">{{ safeValue }}</a>
            <span *ngIf="!isLink">{{ safeValue }}</span>

            <button *ngIf="isDisplayDatePickerIcon === true" mat-icon-button class="icon" (click)="onDatePickerIconClick($event)"
            [matTooltip]="datePickerIconTooltip">
              <mat-icon>today</mat-icon>
            </button>
          </span>
        </div>


        <mat-form-field class="datepicker">
          <input matInput class="hidden" [matDatepicker]="datePicker" hidden (dateChange)="onDateSelected($event)">
          <mat-datepicker #datePicker ></mat-datepicker>
        </mat-form-field>
      </mat-list-item>
      <mat-divider></mat-divider>
    </mat-list>
  `,
  styles: [`

    .datepicker {
      height: 0px !important;
      display: block;
    }

    mat-icon {
      color: #424242;
    }

    .icon {
      position: absolute;
      padding: 0px !important;
      margin: -3px 0px 0px 08px !important;
      height: 25px !important;
      width: 25px !important;
      right: 10px;
    }
    .detail-view-item-list {
      padding: 3px 0px 3px 0;
    }
    .mat-divider {
      border-top-color: #a9a9a9;
    }
    .detail-view-item-list-item-container {
      display: flex;
      align-items: flex-start; 
      margin: 0;
      min-height: 20px;
      height: auto;
      padding: 0;
    }
    .vertical-display {
      display: flex;
      flex-direction: column;
    }
    .horizontal-display {
      display: flex;
      flex-direction: row;
      justify-content: left;
    }
    .detail-view-item-content {
      display: flex;
      justify-content:  left;
      flex-direction: row;
      width: 100%;
    }
    .detail-view-item-list-item-title {
      /* 
      font-weight: bold; 
      */
      font-weight: bold;
      font-size: calc(100% - 0.5pt); 
      color: #6a6a6a;
      flex-shrink: 0; 
      overflow-wrap: break-word; 
      word-break: break-word; 
      white-space: normal;
    }
    .detail-view-item-list-item-value {
      overflow-wrap: break-word;
      flex-grow: 1; 
      /* white-space: pre-wrap; */
    }
    /* Title alignment styles */
    .title-left-align {
      text-align: left;
    }
    .title-right-align {
      text-align: right;
      width: 100%;
    }
    .title-center-align {
      text-align: center;
    }
    /* Value alignment styles */
    .value-left-align {
      text-align: left;
    }
    .value-right-align {
      text-align: right;
    }
    .value-center-align {
      text-align: center;
    }
  `],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ]
})
export class DetailViewItemComponent {
  @Input() title: string | undefined;
  @Input() value: any | undefined | null = null;
  @Input() displayMode: 'horizontal' | 'vertical' = 'horizontal'; /* デフォルトは縦 horizontal */
  @Input() textAlign: 'left' | 'right' | 'center' = 'left'; /* デフォルトは左揃え */
  @Input() titleTextAlign: 'left' | 'right' | 'center' = 'left'; /* タイトルのデフォルトは左揃え */
  @Input() titleWidth: string = '112px'; /* デフォルト幅は112px */
  @Input() isLink: boolean = false; // リンクかどうか
  @Input() onClick: (event: Event) => void = () => { }; // クリックイベント用の関数を親から受け取る
  @Input() datePickerIconTooltip: string = "";
  @Input() datePickerDate: string | Moment | Date | undefined = "";
  @Input() onSelectDatePicker: (date: string) => void = () => { }; // YYYY-MM-DDフォーマット
  @Input() isDisplayDatePickerIcon: boolean = false;

  @Input() whiteSpace: 'normal' | 'nowrap' | 'pre' | 'pre-wrap' | 'pre-line' = 'pre-wrap';


  @ViewChild('datePicker') datePicker!: MatDatepicker<any>;

  get safeValue(): string {
    return this.value || '';
  }

  getTitleWidth(): string {
    return this.titleWidth != '112px' ? this.titleWidth : (this.displayMode === 'vertical' ? '100%' : this.titleWidth);
  }

  onValueClick(event: Event) {
    event.preventDefault();
    if (this.onClick) {
      this.onClick(event);
    }
  }


  onDatePickerIconClick(event: Event) {
    event.preventDefault();

    if (this.datePickerDate) {
      let momentDate;

      // datePickerDate が Moment 型の場合
      if (moment.isMoment(this.datePickerDate)) {
        momentDate = this.datePickerDate;
      }
      // datePickerDate が Date 型の場合、Moment 型に変換
      else if (this.datePickerDate instanceof Date) {
        momentDate = moment(this.datePickerDate);
      }
      // datePickerDate が string 型の場合、Moment 型に変換
      else if (typeof this.datePickerDate === 'string') {
        momentDate = moment(this.datePickerDate, 'YYYY-MM-DD');
      }

      if (momentDate && momentDate.isValid()) {
        this.datePicker.startAt = momentDate;
      }
    }
    this.datePicker.open(); // カレンダーを表示
  }

  onDateSelected(event: any) {
    this.onSelectDatePicker(event.value.format('YYYY-MM-DD'));
  }

}
